<template>
  <div class="headin">
    <p>
      <slot></slot>
    </p>

    <button v-if="!hideClose" class="hover_op" @click="$store.commit('hideModal', true)">
      <span>Close</span
      ><img src="@/assets/img/mob_close_menu_icon.svg" alt=""/>
    </button>
  </div>
</template>

<script>
export default {
  props: ["hideClose"]
}
</script>
